import React, { useEffect, useState } from "react";
import fileDownload from "js-file-download";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  LineElement,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { get, getFile } from "../../../../api";
ChartJS.register(
  CategoryScale,
  LinearScale,
  LineElement,
  Title,
  Tooltip,
  Legend
);

function Revenue() {
  const [revenueType, setRevenueType] = useState("month");
  const [revenue, setRevenue] = useState({
    labels: [],
    datasets: [
      {
        label: "Revenue",
        data: [],
        backgroundColor: "#1865cd",
      },
    ],
  });

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
    },
  };
  useEffect(() => {
    getRevenue(false);
  }, []);
  const getRevenue = async (isDownload, type) => {
    try {
      let url = `/user/report/revenue?type=${
        type ? type : revenueType
      }&download=${isDownload}`;
      let response;
      if (isDownload) {
        response = await getFile(url);
      } else {
        response = await get(url);
      }
      let labels = [];
      let data = [];
      if (isDownload && response?.data) {
        fileDownload(
          response?.data,
          response?.headers?.["content-disposition"]?.split("filename=")[1]
        );
      }
      if (!isDownload && response?.count) {
        for (const [key, value] of Object.entries(response?.count)) {
          labels.push(key);
          data.push(value);
        }
        setRevenue({
          labels: labels,
          datasets: [
            {
              label: "Revenue",
              data: data,
              backgroundColor: "#1865cd",
            },
          ],
        });
      }
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <>
      <div className="widget-title">
        <h4>Revenue</h4>
        <div className="chosen-outer">
          <select
            className="chosen-select-revenue"
            onChange={(e) => {
              e?.stopPropagation();
              setRevenueType(e?.target?.value);
              getRevenue(false, e?.target?.value);
            }}
          >
            <option value={"month"}>Last 6 Months</option>
            <option value={"week"}>Last 24 Weeks</option>
          </select>
          <div>
            <button
              type="button"
              className="theme-btn btn-sm btn-style-three"
              onClick={(e) => {
                e?.stopPropagation();
                getRevenue(true);
              }}
            >
              Download
            </button>
          </div>
        </div>
      </div>

      <div className="widget-content">
        <Line options={options} data={revenue} />
      </div>
    </>
  );
}

export default Revenue;
